// Environment variable utility for Magnus Resolve
// SECURITY: No API keys should be accessed from frontend
// ============================================================

export const getEnv = (key: string): string | undefined => {
    try {
        if (import.meta?.env) {
            const value = import.meta.env[key];
            if (value && typeof value === 'string') return value;
        }
    } catch {
        // Not in Vite environment
    }

    if (typeof process !== 'undefined' && process.env) {
        const value = process.env[key];
        if (value) return value;
    }

    return undefined;
};

export default { getEnv };
